import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import api from "@/lib/api";
import { LeadCard, LeadCardSkeleton, EmptyState } from "@/components/telecaller/LeadCard";
import { useBulkSelect, BulkSelectToggle, BulkStatusBar } from "@/components/telecaller/BulkSelect";
import { Flame } from "lucide-react";

export default function HotLeads() {
  const { refreshUnread } = useOutletContext();
  const [items, setItems] = useState(null);
  const [statuses, setStatuses] = useState([]);
  const bulk = useBulkSelect();

  const load = () => {
    api.get("/leads", { params: { hot: true, page_size: 50 } }).then((r) => setItems(r.data.items)).catch(() => setItems([]));
    refreshUnread && refreshUnread();
  };
  useEffect(() => {
    api.get("/lead-statuses").then((r) => setStatuses(r.data.items)).catch(() => {});
    load();
  }, []);

  return (
    <div className="space-y-4 pb-28">
      <header className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-xl bg-red-500/15 flex items-center justify-center"><Flame className="h-5 w-5 text-red-400" /></div>
          <div>
            <h1 className="font-heading text-xl font-extrabold">Hot Leads</h1>
            <p className="text-xs text-slate-400">Interested & high-priority — call now.</p>
          </div>
        </div>
        {items && items.length > 0 && (
          <BulkSelectToggle selectMode={bulk.selectMode} onEnter={() => bulk.setSelectMode(true)} onExit={bulk.exit} />
        )}
      </header>

      <div className="space-y-3">
        {items === null && [0, 1].map((i) => <LeadCardSkeleton key={i} />)}
        {items !== null && items.length === 0 && <EmptyState icon={Flame} title="No hot leads yet." subtitle="Interested leads will appear here." />}
        {items?.map((l) => <LeadCard key={l.id} lead={l} statuses={statuses} onChanged={load}
          selectable={bulk.selectMode} selected={bulk.selected.has(l.id)} onToggleSelect={bulk.toggleSel} />)}
      </div>

      {bulk.selectMode && (
        <BulkStatusBar count={bulk.selected.size} statuses={statuses}
          onDone={{ ids: () => [...bulk.selected], done: () => { bulk.exit(); load(); } }} />
      )}
    </div>
  );
}
